import { render, staticRenderFns } from "./AboutDiabetes.vue?vue&type=template&id=ada0421e&scoped=true&"
import script from "./AboutDiabetes.vue?vue&type=script&lang=js&"
export * from "./AboutDiabetes.vue?vue&type=script&lang=js&"
import style0 from "./AboutDiabetes.vue?vue&type=style&index=0&id=ada0421e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada0421e",
  null
  
)

export default component.exports